import { createContext } from "react";
import type { DialogContextProps, DialogState } from "./DialogProvider";

export const DialogContext = createContext<DialogContextProps>(null!);
export const DialogStateContext = createContext<DialogState<unknown>>(null!);
